import { useCallback } from 'react';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

function usePaymentErrorCodeTranslation(integrationType?: string) {
  const t = useTranslationOrders('abandonedCarts.payments.errors');

  return useCallback(
    (errorCode?: string): string => {
      const defaultKey = ['modal', 'redirect'].includes(integrationType ?? '')
        ? 'redirect'
        : 'default';

      if (!errorCode) {
        return t(defaultKey);
      }

      return t(errorCode, { defaultValue: t(defaultKey) });
    },
    [integrationType, t],
  );
}

export default usePaymentErrorCodeTranslation;
